import { map } from 'rxjs/operators';
import {ReservationService} from '../services/reservation.service';
import {HotelService} from '../services/hotel.service';
import {AppAction, AppActionState, IAppState} from '../../store/interfaces/IAppState';
import {NgRedux} from '@angular-redux/store';
import {LogService} from '../services/logging.service';
import {Actions} from '../../store/actions';
import {MemberService} from '../services/member.service';
import {User} from '../model/user/user.model';
import {UserStatusType} from '../model/user/user-status-type.model';
import { getFutureHotelDecorator } from './utils';

const CLASS_NAME = 'CommonActionsDelegate';
export class CommonActionsDelegate {
  constructor(protected _ngRedux: NgRedux<IAppState>,
              protected _actions: Actions,
              protected _logService: LogService,
              protected _reservationService: ReservationService,
              protected _hotelService: HotelService,
              protected _memberService: MemberService) {
  }

  fetchReservation(reservationId: string, lastName: string, useCache?: boolean) {
    this._actions.dispatchReservationAction(AppAction.GET_RESERVATION, AppActionState.INITIAL);
    this._reservationService.getReservation(reservationId, lastName, useCache)
      .subscribe( reservation => {
          this._logService.info(`Reservation successfully retrieved: ${reservation.confirmationNumber}`, CLASS_NAME);
          this._actions.dispatchReservationAction(AppAction.GET_RESERVATION, AppActionState.SUCCESS, reservation);
        },
        error => {
          this._logService.warn(`Error retrieving hotel reservation. Reservation: ${reservationId}, Last Name: ${lastName}`, CLASS_NAME, error);
          this._actions.dispatchReservationAction(AppAction.GET_RESERVATION, AppActionState.ERROR, null, error);
        }
      );
  }

  fetchHotel(hotelMnemonic: string) {
    this._actions.dispatchHotelAction(AppAction.GET_HOTEL, AppActionState.INITIAL);
    this._hotelService.getHotel(hotelMnemonic, true)
      .pipe(
        map(hotel => {
          const state = this._ngRedux.getState();
          const getRebrandedHotel = getFutureHotelDecorator(state);
          return getRebrandedHotel(hotel);
        })
      )
      .subscribe(hotel => {
        this._actions.dispatchHotelAction(AppAction.GET_HOTEL, AppActionState.SUCCESS, hotel);
      },
        error => {
          this._logService.warn(`Error retrieving hotel: ${hotelMnemonic}`, CLASS_NAME, error);
          this._actions.dispatchHotelAction(AppAction.GET_HOTEL, AppActionState.ERROR, null, error);
        }
      );
  }

  fetchMember(appAction: AppAction = AppAction.GET_MEMBER, defaultMember: User =  new User(UserStatusType.ANONYMOUS)) {
    this._actions.dispatchMemberAction(appAction, AppActionState.INITIAL, this._ngRedux.getState().member);
    this._memberService.getMember()
      .subscribe( member => {
          this._actions.dispatchMemberAction(appAction, AppActionState.SUCCESS, member);
        },
        error => {
          this._logService.warn(`Error retrieving member information`, CLASS_NAME, error);
          this._actions.dispatchMemberAction(appAction, AppActionState.ERROR, defaultMember, error);
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/delegates/common-actions.delegate.ts